"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NavComponent =
/*#__PURE__*/
function () {
  function NavComponent() {
    _classCallCheck(this, NavComponent);

    this._mobileMenu = $("#mobileMenu");
    this._openMobileMenuButton = $("#openMobileMenuButton");
    this._closeMobileMenuButton = $("#closeMobileMenuButton");
    this._scrollLinks = $('a.scroll');
    this.init();
  }

  _createClass(NavComponent, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this._openMobileMenuButton.click(function (e) {
        _this2._mobileMenu.slideDown(600);
      });

      this._closeMobileMenuButton.click(function (e) {
        _this2._mobileMenu.slideUp(600);
      });

      $(document).on('click', 'a.scroll', function (e) {
        var _this = $(e.currentTarget); // LOAD HASH FROM URL


        var hash = _this[0].hash;

        if (hash !== "") {
          _this2._mobileMenu.hide();

          e.preventDefault(); // SCROLL TO SECTION

          $('html, body').animate({
            scrollTop: $(hash).offset().top
          }, 300, function () {
            window.location.hash = hash;
          });
        }
      });
    }
  }]);

  return NavComponent;
}();